import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

import { CurrencyUtils, OrderViewUtils } from 'PMT/utils';

// -- entities
import Order from 'PMT/entities/order/Order';

// -- utils
import PhoneUtils from 'PMT/utils/PhoneUtils';
import classNames from 'classnames';

// -- views
import SvgIcon from 'PMT/components/SvgIcon';
import { OrderStatusLabel } from 'components/order';

import { ModalType } from '../constants'

/**
 * @parents OrdersReadyView, OrdersNotReadyView
 */
class OrderRowView extends Component {

  static propTypes = {
    order: PropTypes.instanceOf(Order),

    selected: PropTypes.bool.isRequired,

    /**
     * parameter: Order
     */
    onSelected: PropTypes.func.isRequired,

    currencyCode: PropTypes.string,

  };

  onSelect = modalType => {
    this.props.onSelected(this.props.order, modalType);
  }

  render() {
    const order:Order = this.props.order;
    const currencyCode: string = this.props.currencyCode;

    const className = classNames('order_row_view', 'pointer', {
      selected: this.props.selected
    });

    try {
    return (
      <tr className={className} onClick={() => this.onSelect(ModalType.DETAIL)}>
        <td className="text-left">
          {order.dueDate.format('HH:mm')}
        </td>
        <td>
          {!order.isOnBar() &&
            <SvgIcon
              icon={OrderViewUtils.getIconForMode(order.mode)}
              style={styles.icon}
            />
          }
          {order.isOnBar() &&
            <SvgIcon
              icon={SvgIcon.ORDER_AT_BAR}
              style={styles.icon}
            />
          }
        </td>
        <td>
          {!_.isNull(order.user) &&
            `${order.user.firstName || ''} ${order.user.lastName || ''}`
          }
        </td>
        <td className="hidden-xs hidden-sm">
          {!_.isNull(order.user) &&
            PhoneUtils.format(order.user.phone)
          }
        </td>
        <td>
          {/* {order.isPayed() ? */}
          {/* ( */}
          <span>
            {CurrencyUtils.formatPriceWithCurrency(order.check.total,
                currencyCode)}
          </span>
          {/* ) : (
              <span>
                {I18n.tr('order.history.on_site')}
              </span>
            )
          } */}
        </td>
        <td className="text-right">
          {order.isCancelable() ? (
            <button
              type="button"
              className="btn btn-sm btn-link btn-cancel"
              onClick={e => {
                e.stopPropagation()
                e.preventDefault()
                this.onSelect(ModalType.CANCEL)
              }}
            >
              {I18n.tr('order.on_going.cancel')}
            </button>
          ) : (
            <span className="btn btn-sm text-muted disabled">
              {I18n.tr('order.on_going.not_cancelable')}
            </span>
          )}
        </td>
        <td className="text-center">
          <OrderStatusLabel
            status={order.status}
          />
        </td>
      </tr>
    );
    } catch (e) { console.error(e); }
  }

}

const styles = {
  icon: {
    height: '25px',
    width: 'auto'
  }
}

export default OrderRowView;
